'use client';

// Third Party Plugins
import React from 'react';
// Types
import { ClientSideJoinWrapperProps } from './types';
// Styles
import { StyledInstructions } from './styles';
// Custom Components
import LayoutContainer from '@/components/ui/LayoutContainer';
import HeroHeading from '@/components/ui/HeroHeading';
import ImageContainer from '@/components/images/ImageContainer';
import FormComponent from '../FormComponent';

import GallerySection from '@/components/images/Gallery/components/GallerySection';

const ClientSideJoinWrapper: React.FC<ClientSideJoinWrapperProps> = ({
  headingOne,
  subheading,
  instructions,
  pageImageBlock,
  hasGallery,
  galleryManyBlock,
}) => {
  return (
    <>
      <HeroHeading>
        <h1>{headingOne}</h1>
        <p>{subheading}</p>
        {pageImageBlock?.asset?.url && (
          <ImageContainer
            image={pageImageBlock?.asset?.url ?? null}
            type="dynamic"
            alt={pageImageBlock?.alt ? pageImageBlock.alt : ``}
            width={751}
            height={312}
          />
        )}
      </HeroHeading>
      <StyledInstructions>
        <em>{instructions}</em>
      </StyledInstructions>
      <LayoutContainer hasSectionGaps>
        <FormComponent />
        {/* {hasGallery && <Gallery images={galleryManyBlock || []} />} */}

        <GallerySection
          hasGallery={hasGallery}
          galleryManyBlock={galleryManyBlock || []}
        />
      </LayoutContainer>
    </>
  );
};

export default ClientSideJoinWrapper;
